import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  R: () => (/* binding */ IconSustainableEconyl)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconSustainableEconyl.tsx


const IconSustainableEconyl = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-econyl-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5, stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M24.0069 13.8993L23.957 13.9492C23.508 14.6976 23.1089 15.396 22.6599 16.1443C22.6599 16.1942 22.61 16.2441 22.61 16.2441V17.4414C22.61 17.5412 22.61 17.5412 22.5103 17.5412C22.161 17.5412 21.8118 17.5412 21.4127 17.5412C21.3129 17.5412 21.3129 17.5412 21.3129 17.4414C21.3129 17.0423 21.3129 16.6432 21.3129 16.2441C21.3129 16.1942 21.3129 16.1443 21.263 16.1443C20.814 15.396 20.4149 14.6976 19.9659 13.9492C19.9659 13.9492 19.9659 13.8993 19.916 13.8993V13.9991V16.5933V17.4913C19.916 17.5412 19.916 17.5911 19.8163 17.5911C19.4671 17.5911 19.1677 17.5911 18.8185 17.5911C18.7686 17.5911 18.7187 17.5911 18.7187 17.5412C18.2697 16.9924 17.8706 16.4437 17.4216 15.9448C17.4216 15.9448 17.3717 15.8949 17.3717 15.845V15.9448V17.4913C17.3717 17.5911 17.3717 17.5911 17.272 17.5911C16.9227 17.5911 16.5735 17.5911 16.2243 17.5911C16.1744 17.5911 16.1245 17.5911 16.1245 17.4913C16.1245 16.294 16.1245 15.0967 16.1245 13.8495C16.1245 13.7996 16.1245 13.7497 16.2243 13.7497H17.272C17.3218 13.7497 17.3717 13.7497 17.3717 13.7996C17.7708 14.2985 18.2198 14.8472 18.6189 15.3461L18.6688 15.396C18.6688 15.3461 18.6688 15.3461 18.6688 15.2962C18.6688 14.7973 18.6688 14.2985 18.6688 13.7996C18.6688 13.7497 18.6688 13.6998 18.7686 13.6998H19.7664H21.2132C21.263 13.6998 21.3129 13.6998 21.3129 13.7497C21.5125 14.0989 21.712 14.498 21.9116 14.8472C21.9116 14.8472 21.9116 14.8971 21.9615 14.8971C21.9615 14.8472 22.0114 14.8472 22.0114 14.7973C22.2109 14.4481 22.4105 14.049 22.61 13.6998C22.61 13.6499 22.6599 13.6499 22.7098 13.6499H23.8573H25.1045C25.2042 13.6499 25.2042 13.6499 25.2042 13.7497V16.2441C25.2042 16.3439 25.2042 16.3439 25.304 16.3439H26.9005C26.9503 16.3439 27.0002 16.3439 27.0002 16.4437V17.3417C27.0002 17.3916 27.0002 17.4414 26.9005 17.4414C25.9526 17.4414 24.9548 17.4414 24.0069 17.4414C23.957 17.4414 23.9071 17.4414 23.9071 17.3417C23.9071 16.1942 23.9071 15.0468 23.9071 13.8495C24.0069 13.9991 24.0069 13.9492 24.0069 13.8993V13.8993Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M12.2834 16.743C12.5827 16.4437 12.882 16.1444 13.1814 15.845L13.2312 15.8949C13.3809 15.9947 13.4807 16.1444 13.6304 16.2441C14.0295 16.5435 14.6281 16.294 14.7279 15.7952C14.7778 15.4958 14.6281 15.1965 14.3787 15.0468C14.1292 14.8972 13.78 14.8972 13.5306 15.0967C13.3809 15.1965 13.2811 15.3462 13.1315 15.4459C12.6326 15.9448 12.1337 16.4437 11.6348 16.9925C11.3854 17.2419 11.086 17.4914 10.7368 17.5911C9.98848 17.8406 9.09049 17.5911 8.5916 16.8927C7.79338 15.8949 8.19249 14.3983 9.33993 13.8994C9.63926 13.7497 9.8887 13.6998 10.188 13.6998C10.7368 13.6998 11.1858 13.8994 11.5849 14.2985C11.6348 14.3484 11.6847 14.3983 11.6847 14.3983C11.3854 14.6976 11.086 14.9969 10.7867 15.2963C10.7368 15.2464 10.6869 15.1965 10.5871 15.1466C10.3876 14.9969 10.1381 14.947 9.8887 14.9969C9.53948 15.0967 9.33993 15.4459 9.38982 15.7952C9.43971 16.1444 9.73904 16.3938 10.0883 16.4437C10.2878 16.4437 10.4375 16.3938 10.5871 16.294C10.6869 16.1943 10.7867 16.0945 10.8865 15.9947C11.2856 15.5956 11.7346 15.1466 12.1337 14.7475C12.3332 14.498 12.5827 14.2985 12.8321 14.0989C13.1315 13.8994 13.4807 13.7497 13.8299 13.7497C14.6281 13.6998 15.2767 14.049 15.6758 14.7475C16.2246 15.7453 15.8255 17.0424 14.7778 17.4914C14.5283 17.5911 14.3288 17.641 14.0793 17.6909C13.5306 17.7408 13.0816 17.5413 12.6825 17.192C12.5827 17.0424 12.433 16.8927 12.2834 16.743V16.743Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M4.84994 15.6953C4.84994 15.0967 4.84994 14.498 4.84994 13.8494C4.84994 13.7996 4.84994 13.7996 4.89983 13.7996H7.99292C8.04281 13.7996 8.04281 13.7996 8.04281 13.8494V14.7474C8.04281 14.7973 8.04281 14.7973 7.99292 14.7973C7.39426 14.7973 6.74571 14.7973 6.14704 14.7973C6.04726 14.7973 6.04726 14.7973 6.04726 14.8971V15.1466C6.04726 15.1964 6.04726 15.1964 6.09715 15.1964H6.64593H7.69359C7.74348 15.1964 7.79337 15.1964 7.79337 15.2962V16.0445C7.79337 16.0944 7.79337 16.1443 7.69359 16.1443C7.1947 16.1443 6.64593 16.1443 6.14704 16.1443C6.04726 16.1443 6.04726 16.1443 6.04726 16.2441V16.4935C6.04726 16.5434 6.04726 16.5434 6.09715 16.5434H7.94303C8.04281 16.5434 8.04281 16.5434 8.04281 16.6432V17.5412C8.04281 17.5911 8.04281 17.5911 7.99292 17.5911C6.94526 17.5911 5.8976 17.5911 4.84994 17.5911C4.80005 17.5911 4.80005 17.5911 4.80005 17.5412C4.84994 16.8927 4.84994 16.294 4.84994 15.6953V15.6953Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M26.4517 15.0967C26.0526 15.0967 25.7533 14.7475 25.7034 14.3484C25.7034 13.9493 26.0526 13.6 26.4517 13.6C26.8508 13.6 27.2 13.8994 27.2 14.3484C27.2 14.7475 26.8508 15.0967 26.4517 15.0967ZM26.4517 15.0468C26.8009 15.0468 27.1003 14.7475 27.1003 14.3983C27.1003 13.9991 26.8009 13.7497 26.4517 13.7497C26.0526 13.7497 25.8031 14.049 25.8031 14.3983C25.8031 14.7475 26.1025 15.0468 26.4517 15.0468Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M26.8505 14.7474C26.8006 14.6476 26.7507 14.5478 26.6509 14.4979H26.7008C26.8006 14.4481 26.8505 14.3483 26.8505 14.2485C26.8505 14.1487 26.7507 14.049 26.6509 14.049C26.5012 14.049 26.4015 14.049 26.2518 14.049C26.2019 14.049 26.2019 14.049 26.2019 14.0988V14.6476C26.2019 14.7973 26.2019 14.7973 26.3516 14.7973L26.4015 14.7474C26.4015 14.6975 26.4015 14.6476 26.4015 14.5977C26.4015 14.5977 26.4015 14.5478 26.4513 14.5478C26.5012 14.5478 26.5511 14.5478 26.5511 14.5977C26.601 14.6476 26.601 14.6975 26.6509 14.7474L26.7008 14.7973C26.7008 14.7474 26.7507 14.7474 26.8505 14.7474V14.7474Z", fill: "white" }), (0,jsx_runtime.jsx)("path", { d: "M26.851 14.7475C26.7513 14.7475 26.7014 14.7475 26.6515 14.7475C26.6515 14.7475 26.6016 14.7475 26.6016 14.6976C26.5517 14.6477 26.5018 14.5978 26.5018 14.5479C26.4519 14.498 26.4519 14.498 26.402 14.498L26.3521 14.5479V14.6976L26.3023 14.7475C26.1526 14.7475 26.1526 14.7475 26.1526 14.5978C26.1526 14.3983 26.1526 14.1987 26.1526 14.049C26.1526 13.9991 26.1526 13.9991 26.2025 13.9991H26.6016C26.7014 13.9991 26.8011 14.0989 26.8011 14.1987C26.8011 14.2985 26.8011 14.3983 26.6515 14.4481C26.6515 14.4481 26.6515 14.4481 26.6016 14.4481C26.7513 14.5479 26.8011 14.6477 26.851 14.7475V14.7475ZM26.4519 14.3484H26.5517C26.6016 14.3484 26.6515 14.2985 26.6515 14.2486C26.6515 14.1987 26.6016 14.1488 26.5517 14.1488C26.5018 14.1488 26.4519 14.1488 26.402 14.1488C26.3023 14.1488 26.3521 14.2486 26.3521 14.2985C26.3521 14.3484 26.3521 14.3484 26.402 14.3484H26.4519C26.402 14.3484 26.4519 14.3484 26.4519 14.3484V14.3484Z", fill: "#00174F" })] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-econyl-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5, stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M24.0069 13.8993L23.957 13.9492C23.508 14.6976 23.1089 15.396 22.6599 16.1443C22.6599 16.1942 22.61 16.2441 22.61 16.2441V17.4414C22.61 17.5412 22.61 17.5412 22.5103 17.5412C22.161 17.5412 21.8118 17.5412 21.4127 17.5412C21.3129 17.5412 21.3129 17.5412 21.3129 17.4414C21.3129 17.0423 21.3129 16.6432 21.3129 16.2441C21.3129 16.1942 21.3129 16.1443 21.263 16.1443C20.814 15.396 20.4149 14.6976 19.9659 13.9492C19.9659 13.9492 19.9659 13.8993 19.916 13.8993V13.9991V16.5933V17.4913C19.916 17.5412 19.916 17.5911 19.8163 17.5911C19.4671 17.5911 19.1677 17.5911 18.8185 17.5911C18.7686 17.5911 18.7187 17.5911 18.7187 17.5412C18.2697 16.9924 17.8706 16.4437 17.4216 15.9448C17.4216 15.9448 17.3717 15.8949 17.3717 15.845V15.9448V17.4913C17.3717 17.5911 17.3717 17.5911 17.272 17.5911C16.9227 17.5911 16.5735 17.5911 16.2243 17.5911C16.1744 17.5911 16.1245 17.5911 16.1245 17.4913C16.1245 16.294 16.1245 15.0967 16.1245 13.8495C16.1245 13.7996 16.1245 13.7497 16.2243 13.7497H17.272C17.3218 13.7497 17.3717 13.7497 17.3717 13.7996C17.7708 14.2985 18.2198 14.8472 18.6189 15.3461L18.6688 15.396C18.6688 15.3461 18.6688 15.3461 18.6688 15.2962C18.6688 14.7973 18.6688 14.2985 18.6688 13.7996C18.6688 13.7497 18.6688 13.6998 18.7686 13.6998H19.7664H21.2132C21.263 13.6998 21.3129 13.6998 21.3129 13.7497C21.5125 14.0989 21.712 14.498 21.9116 14.8472C21.9116 14.8472 21.9116 14.8971 21.9615 14.8971C21.9615 14.8472 22.0114 14.8472 22.0114 14.7973C22.2109 14.4481 22.4105 14.049 22.61 13.6998C22.61 13.6499 22.6599 13.6499 22.7098 13.6499H23.8573H25.1045C25.2042 13.6499 25.2042 13.6499 25.2042 13.7497V16.2441C25.2042 16.3439 25.2042 16.3439 25.304 16.3439H26.9005C26.9503 16.3439 27.0002 16.3439 27.0002 16.4437V17.3417C27.0002 17.3916 27.0002 17.4414 26.9005 17.4414C25.9526 17.4414 24.9548 17.4414 24.0069 17.4414C23.957 17.4414 23.9071 17.4414 23.9071 17.3417C23.9071 16.1942 23.9071 15.0468 23.9071 13.8495C24.0069 13.9991 24.0069 13.9492 24.0069 13.8993V13.8993Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M12.2834 16.743C12.5827 16.4437 12.882 16.1444 13.1814 15.845L13.2312 15.8949C13.3809 15.9947 13.4807 16.1444 13.6304 16.2441C14.0295 16.5435 14.6281 16.294 14.7279 15.7952C14.7778 15.4958 14.6281 15.1965 14.3787 15.0468C14.1292 14.8972 13.78 14.8972 13.5306 15.0967C13.3809 15.1965 13.2811 15.3462 13.1315 15.4459C12.6326 15.9448 12.1337 16.4437 11.6348 16.9925C11.3854 17.2419 11.086 17.4914 10.7368 17.5911C9.98848 17.8406 9.09049 17.5911 8.5916 16.8927C7.79338 15.8949 8.19249 14.3983 9.33993 13.8994C9.63926 13.7497 9.8887 13.6998 10.188 13.6998C10.7368 13.6998 11.1858 13.8994 11.5849 14.2985C11.6348 14.3484 11.6847 14.3983 11.6847 14.3983C11.3854 14.6976 11.086 14.9969 10.7867 15.2963C10.7368 15.2464 10.6869 15.1965 10.5871 15.1466C10.3876 14.9969 10.1381 14.947 9.8887 14.9969C9.53948 15.0967 9.33993 15.4459 9.38982 15.7952C9.43971 16.1444 9.73904 16.3938 10.0883 16.4437C10.2878 16.4437 10.4375 16.3938 10.5871 16.294C10.6869 16.1943 10.7867 16.0945 10.8865 15.9947C11.2856 15.5956 11.7346 15.1466 12.1337 14.7475C12.3332 14.498 12.5827 14.2985 12.8321 14.0989C13.1315 13.8994 13.4807 13.7497 13.8299 13.7497C14.6281 13.6998 15.2767 14.049 15.6758 14.7475C16.2246 15.7453 15.8255 17.0424 14.7778 17.4914C14.5283 17.5911 14.3288 17.641 14.0793 17.6909C13.5306 17.7408 13.0816 17.5413 12.6825 17.192C12.5827 17.0424 12.433 16.8927 12.2834 16.743V16.743Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M4.84994 15.6953C4.84994 15.0967 4.84994 14.498 4.84994 13.8494C4.84994 13.7996 4.84994 13.7996 4.89983 13.7996H7.99292C8.04281 13.7996 8.04281 13.7996 8.04281 13.8494V14.7474C8.04281 14.7973 8.04281 14.7973 7.99292 14.7973C7.39426 14.7973 6.74571 14.7973 6.14704 14.7973C6.04726 14.7973 6.04726 14.7973 6.04726 14.8971V15.1466C6.04726 15.1964 6.04726 15.1964 6.09715 15.1964H6.64593H7.69359C7.74348 15.1964 7.79337 15.1964 7.79337 15.2962V16.0445C7.79337 16.0944 7.79337 16.1443 7.69359 16.1443C7.1947 16.1443 6.64593 16.1443 6.14704 16.1443C6.04726 16.1443 6.04726 16.1443 6.04726 16.2441V16.4935C6.04726 16.5434 6.04726 16.5434 6.09715 16.5434H7.94303C8.04281 16.5434 8.04281 16.5434 8.04281 16.6432V17.5412C8.04281 17.5911 8.04281 17.5911 7.99292 17.5911C6.94526 17.5911 5.8976 17.5911 4.84994 17.5911C4.80005 17.5911 4.80005 17.5911 4.80005 17.5412C4.84994 16.8927 4.84994 16.294 4.84994 15.6953V15.6953Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M26.4517 15.0967C26.0526 15.0967 25.7533 14.7475 25.7034 14.3484C25.7034 13.9493 26.0526 13.6 26.4517 13.6C26.8508 13.6 27.2 13.8994 27.2 14.3484C27.2 14.7475 26.8508 15.0967 26.4517 15.0967ZM26.4517 15.0468C26.8009 15.0468 27.1003 14.7475 27.1003 14.3983C27.1003 13.9991 26.8009 13.7497 26.4517 13.7497C26.0526 13.7497 25.8031 14.049 25.8031 14.3983C25.8031 14.7475 26.1025 15.0468 26.4517 15.0468Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M26.8505 14.7474C26.8006 14.6476 26.7507 14.5478 26.6509 14.4979H26.7008C26.8006 14.4481 26.8505 14.3483 26.8505 14.2485C26.8505 14.1487 26.7507 14.049 26.6509 14.049C26.5012 14.049 26.4015 14.049 26.2518 14.049C26.2019 14.049 26.2019 14.049 26.2019 14.0988V14.6476C26.2019 14.7973 26.2019 14.7973 26.3516 14.7973L26.4015 14.7474C26.4015 14.6975 26.4015 14.6476 26.4015 14.5977C26.4015 14.5977 26.4015 14.5478 26.4513 14.5478C26.5012 14.5478 26.5511 14.5478 26.5511 14.5977C26.601 14.6476 26.601 14.6975 26.6509 14.7474L26.7008 14.7973C26.7008 14.7474 26.7507 14.7474 26.8505 14.7474V14.7474Z", fill: "white" }), (0,jsx_runtime.jsx)("path", { d: "M26.851 14.7475C26.7513 14.7475 26.7014 14.7475 26.6515 14.7475C26.6515 14.7475 26.6016 14.7475 26.6016 14.6976C26.5517 14.6477 26.5018 14.5978 26.5018 14.5479C26.4519 14.498 26.4519 14.498 26.402 14.498L26.3521 14.5479V14.6976L26.3023 14.7475C26.1526 14.7475 26.1526 14.7475 26.1526 14.5978C26.1526 14.3983 26.1526 14.1987 26.1526 14.049C26.1526 13.9991 26.1526 13.9991 26.2025 13.9991H26.6016C26.7014 13.9991 26.8011 14.0989 26.8011 14.1987C26.8011 14.2985 26.8011 14.3983 26.6515 14.4481C26.6515 14.4481 26.6515 14.4481 26.6016 14.4481C26.7513 14.5479 26.8011 14.6477 26.851 14.7475V14.7475ZM26.4519 14.3484H26.5517C26.6016 14.3484 26.6515 14.2985 26.6515 14.2486C26.6515 14.1987 26.6016 14.1488 26.5517 14.1488C26.5018 14.1488 26.4519 14.1488 26.402 14.1488C26.3023 14.1488 26.3521 14.2486 26.3521 14.2985C26.3521 14.3484 26.3521 14.3484 26.402 14.3484H26.4519C26.402 14.3484 26.4519 14.3484 26.4519 14.3484V14.3484Z", fill: "#00174F" })] })));
};

})();

var __webpack_exports__IconSustainableEconyl = __webpack_exports__.R;
export { __webpack_exports__IconSustainableEconyl as IconSustainableEconyl };
